export default "__VITE_ASSET__CDT16l$X__"